const initialPremiumBacklinkState = {
  // Cart management
  cart: [],
  
  // UI state
  modalOpen: false,
  termsModalOpen: false,
  snackbarOpen: false,
  snackbarMessage: '',
  customToastOpen: false,
  customToastMessage: '',
  
  // Data loading state
  isFetching: false,
  isFetchingBacklinks: true,
  isFetchingOrders: true,
  isCreatingOrder: false,
  
  // Error state
  error: null,
  orderError: null,
  
  // Data
  backlinks: [],
  orders: [],
  orderHistory: [],
  clientProfiles: [],
  
  // Pagination
  pagination: {
    currentPage: 0,
    perPage: 50,
    total: 0,
    totalPages: 0,
  },
  
  // Filters
  filters: {
    name: '',
    domain: '',
    dr: '',
    ok: '',
    ot: '',
    price: '',
    rel: '',
    turn_around: '',
    vendor: '',
    notes: '',
  },
  
  // Sorting
  sorting: {
    orderBy: 'dr',
    order: 'desc', // 'asc' or 'desc'
  },
};

const premiumBacklinkActions = {
  SET_CART: 'SET_CART',
  SET_MODAL_OPEN: 'SET_MODAL_OPEN',
  SET_TERMS_MODAL_OPEN: 'SET_TERMS_MODAL_OPEN',
  SET_SNACKBAR: 'SET_SNACKBAR',
  SET_CUSTOM_TOAST: 'SET_CUSTOM_TOAST',
  SET_IS_FETCHING: 'SET_IS_FETCHING',
  SET_IS_FETCHING_BACKLINKS: 'SET_IS_FETCHING_BACKLINKS',
  SET_IS_FETCHING_ORDERS: 'SET_IS_FETCHING_ORDERS',
  SET_IS_CREATING_ORDER: 'SET_IS_CREATING_ORDER',
  SET_ERROR: 'SET_ERROR',
  SET_ORDER_ERROR: 'SET_ORDER_ERROR',
  SET_BACKLINKS: 'SET_BACKLINKS',
  SET_ORDERS: 'SET_ORDERS',
  SET_ORDER_HISTORY: 'SET_ORDER_HISTORY',
  SET_CLIENT_PROFILES: 'SET_CLIENT_PROFILES',
  CLEAR_CART: 'CLEAR_CART',
  CLOSE_SNACKBAR: 'CLOSE_SNACKBAR',
  CLOSE_CUSTOM_TOAST: 'CLOSE_CUSTOM_TOAST',
  SET_PAGINATION: 'SET_PAGINATION',
  SET_CURRENT_PAGE: 'SET_CURRENT_PAGE',
  SET_PER_PAGE: 'SET_PER_PAGE',
  SET_FILTERS: 'SET_FILTERS',
  CLEAR_FILTERS: 'CLEAR_FILTERS',
  SET_SORTING: 'SET_SORTING',
};

function premiumBacklinkReducer(state, action) {
  switch (action.type) {
    case premiumBacklinkActions.SET_CART:
      return {
        ...state,
        cart: action.payload.cart,
      };
    

    case premiumBacklinkActions.SET_MODAL_OPEN:
      return {
        ...state,
        modalOpen: action.payload.modalOpen,
      };
    
    case premiumBacklinkActions.SET_TERMS_MODAL_OPEN:
      return {
        ...state,
        termsModalOpen: action.payload.termsModalOpen,
      };
    
    case premiumBacklinkActions.SET_SNACKBAR:
      return {
        ...state,
        snackbarOpen: action.payload.snackbarOpen,
        snackbarMessage: action.payload.snackbarMessage || state.snackbarMessage,
      };
    
    case premiumBacklinkActions.SET_CUSTOM_TOAST:
      return {
        ...state,
        customToastOpen: action.payload.customToastOpen,
        customToastMessage: action.payload.customToastMessage || state.customToastMessage,
      };
    
    case premiumBacklinkActions.SET_IS_FETCHING:
      return {
        ...state,
        isFetching: action.payload.isFetching,
      };
    
    case premiumBacklinkActions.SET_IS_FETCHING_BACKLINKS:
      return {
        ...state,
        isFetchingBacklinks: action.payload.isFetchingBacklinks,
      };
    
    case premiumBacklinkActions.SET_IS_FETCHING_ORDERS:
      return {
        ...state,
        isFetchingOrders: action.payload.isFetchingOrders,
      };
    
    case premiumBacklinkActions.SET_IS_CREATING_ORDER:
      return {
        ...state,
        isCreatingOrder: action.payload.isCreatingOrder,
      };
    
    case premiumBacklinkActions.SET_ERROR:
      return {
        ...state,
        error: action.payload.error,
      };
    
    case premiumBacklinkActions.SET_ORDER_ERROR:
      return {
        ...state,
        orderError: action.payload.orderError,
      };
    
    case premiumBacklinkActions.SET_BACKLINKS:
      return {
        ...state,
        backlinks: action.payload.backlinks,
      };
    
    case premiumBacklinkActions.SET_ORDERS:
      return {
        ...state,
        orders: action.payload.orders,
      };
    
    case premiumBacklinkActions.SET_ORDER_HISTORY:
      return {
        ...state,
        orderHistory: action.payload.orderHistory,
      };
    
    case premiumBacklinkActions.SET_CLIENT_PROFILES:
      return {
        ...state,
        clientProfiles: action.payload.clientProfiles,
      };
    
    case premiumBacklinkActions.CLEAR_CART:
      return {
        ...state,
        cart: [],
      };
    

    case premiumBacklinkActions.CLOSE_SNACKBAR:
      return {
        ...state,
        snackbarOpen: false,
      };
    
    case premiumBacklinkActions.CLOSE_CUSTOM_TOAST:
      return {
        ...state,
        customToastOpen: false,
      };
    

    case premiumBacklinkActions.SET_PAGINATION:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          ...action.payload,
        },
      };
    
    case premiumBacklinkActions.SET_CURRENT_PAGE:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          currentPage: action.payload.currentPage,
        },
      };
    
    case premiumBacklinkActions.SET_PER_PAGE:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          perPage: action.payload.perPage,
          currentPage: 0, // Reset to first page when changing per page
        },
      };
    
    case premiumBacklinkActions.SET_FILTERS:
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.payload.filters,
        },
        pagination: {
          ...state.pagination,
          currentPage: 0, // Reset to first page when filters change
        },
      };
    
    case premiumBacklinkActions.CLEAR_FILTERS:
      return {
        ...state,
        filters: {
          name: '',
          domain: '',
          dr: '',
          ok: '',
          ot: '',
          price: '',
          rel: '',
          turn_around: '',
          vendor: '',
          notes: '',
        },
        pagination: {
          ...state.pagination,
          currentPage: 0, // Reset to first page when clearing filters
        },
      };
    
    case premiumBacklinkActions.SET_SORTING:
      return {
        ...state,
        sorting: {
          ...state.sorting,
          ...action.payload.sorting,
        },
      };
    
    default:
      return state;
  }
}

export { initialPremiumBacklinkState, premiumBacklinkActions, premiumBacklinkReducer }; 